import React from 'react'
import { Card, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';

function Publication({publication}) {

  const host = process.env.REACT_APP_URL_API;

  const content_style = {
    "overflow": "hidden",
    position: "relative",
  };

  const image_style = {
    width: '80%',
    height: '225px',
    display: 'block',
    borderRadius: '5px',
    "borderRight": "solid 5px #d7d7d7",
    "marginLeft": "auto",
    "marginRight": "auto",
    "maxWidth": "200px",
    zIndex: 0
  };
  return (
    
  <Card style={content_style} className='p-1 pt-4'>
    <Card.Img variant="top" className='shadow p-0' style={image_style} onClick={()=> window.open(`${host}/assets/documents/publications/cover/${publication.publication_id}.jpg`,'_blank')} src={`${host}/assets/documents/publications/cover/${publication.publication_id}.jpg`} />
      
      <Card.Body>
        <Card.Text className='text-center'>Año {publication.year}</Card.Text>
        <Card.Text style={{fontSize:"14px",height:"84px",overflow:"auto"}}>{publication.title}</Card.Text>
        <Button variant="danger" style={{width:"100%"}} onClick={()=> window.open(`/digital-publications-view/${publication.publication_id}`,'_blank')}> <FontAwesomeIcon icon={faFilePdf} /> Abrir PDF</Button>
      </Card.Body>
    </Card>
  )
}

export default Publication